import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackageOverviewContent from "./PackageOverviewContent";

const PackageOverviewPage = () => (
  <PackageOverviewContent
    type="paket"
    title={translate("analyticsPage.package.report_overview")}
    backTo={PATHS.ANALYTICS}
  />
);

export default PackageOverviewPage;
